// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__f7feP","spin":"Spinner_spin__1zpeq","container":"Spinner_container__2ynRC"};